import { ColumnsPreferenceRecognizedLists } from '../../../../services/modules/userContextPreferences/userContextPreferences.types';
import { FilterGroupByEnum } from '../../filter/reportFilter.types';

export const CATEGORY_REPORT_COLUMNS_KEY = 'cpc';

export const SUBCATEGORY_REPORT_COLUMNS_KEY = 'scpc';

export const categoryReportKeysToIgnore = [
  CATEGORY_REPORT_COLUMNS_KEY,
  SUBCATEGORY_REPORT_COLUMNS_KEY,
];

export const CATEGORY_REPORT_COLUMNS_KEYS_BY_GROUP_BY = {
  [FilterGroupByEnum.CATEGORY]: CATEGORY_REPORT_COLUMNS_KEY,
  [FilterGroupByEnum.SUBCATEGORY]: SUBCATEGORY_REPORT_COLUMNS_KEY,
};

export const CATEGORY_REPORT_LIST_BY_GROUP_BY = {
  [FilterGroupByEnum.CATEGORY]: ColumnsPreferenceRecognizedLists.REPORT_CATEGORY_SALES,
  [FilterGroupByEnum.SUBCATEGORY]: ColumnsPreferenceRecognizedLists.REPORT_SUBCATEGORY_SALES,
};
